import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { track } from '../../../utils/analytics';

const INSTALL_TRACKED_KEY = 'hv_install_tracked';

const steps = [
  {
    icon: 'uil uil-puzzle-piece',
    title: 'Pin HighVocab',
    text: 'Click the puzzle icon in your Chrome toolbar and pin HighVocab so it is always one click away.',
  },
  {
    icon: 'uil uil-user-plus',
    title: 'Create your free account',
    text: 'Open HighVocab from the toolbar and sign up so your words are kept and synced across your devices.',
  },
  {
    icon: 'uil uil-bookmark',
    title: 'Save your first word',
    text: 'Open any article, select a word you do not know and save it to your list.',
  },
];

// Opened by the extension's background script right after install.
const PageExtensionInstalled = () => {
  useEffect(() => {
    try {
      if (localStorage.getItem(INSTALL_TRACKED_KEY)) return;
      localStorage.setItem(INSTALL_TRACKED_KEY, '1');
    } catch {}
    const browser = new URLSearchParams(window.location.search).get('browser');
    track('extension_install', { browser: browser || 'chrome' });
  }, []);

  return (
    <React.Fragment>
      <section className="bg-half-170 d-table w-100">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <div
                className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                style={{ height: '90px', width: '90px' }}
              >
                <i className="uil uil-check-circle align-middle h1 mb-0"></i>
              </div>
              <h1 className="my-4 fw-bold">HighVocab is installed!</h1>
              <p className="text-muted para-desc mx-auto">
                You are ready to build your vocabulary while you browse. Three
                quick steps to get the most out of it:
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center mt-4">
            {steps.map((step, idx) => (
              <Col md={4} key={step.title} className="mt-4">
                <div className="card border-0 shadow rounded p-4 h-100 text-center">
                  <i className={`${step.icon} h2 text-primary mb-0`}></i>
                  <h5 className="mt-3">
                    {idx + 1}. {step.title}
                  </h5>
                  <p className="text-muted mb-0">{step.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default PageExtensionInstalled;
